/**
 * Created by denis.gusarov on 4/27/2017.
 */

namespace Factive.Game {
    import Tween = Factive.Core.Tween.Tween;
    import Easing = Factive.Core.Tween.Easing;
    import _ = Factive.Core.Underscore;

    export class ResultTableView extends ViewBase {

        public $model: ResultTableModel;

        public constructor(private _options) {
            super();
        }

        public static factory: any = {
            get (opt): ResultTableView {
                return new ResultTableView(opt);
            },
            dependency: ["Options"]
        };

        public getConfiguration(): IViewConfiguration {

            let childViews = {};
            let i = 1;
            _.each(this.$model.rows, function (row, name) {
                childViews["resultTableRow" + i] ={
                    view: "ResultTableRowView",
                    model: this.$model.rows[name],
                    config: {
                        slot: "ResultTableRow" + i
                    }
                };
                i++;
            }, this);

            return <IViewConfiguration>{
                armatureName: "ResultTable",
                childViews: childViews
                // {
                //     resultTableRow1: {
                //         view: "ResultTableRowView",
                //         model: this.$model.rows.ones,
                //         config: {
                //             slot: "ResultTableRow1"
                //         }
                //     },
                //     resultTableRow2: {
                //         view: "ResultTableRowView",
                //         model: this.$model.rows.twos,
                //         config: {
                //             slot: "ResultTableRow2"
                //         }
                //     },
                //     resultTableRow3: {
                //         view: "ResultTableRowView",
                //         model: this.$model.rows.three,
                //         config: {
                //             slot: "ResultTableRow3"
                //         }
                //     }
                // }
            };
        }

        protected onContentLoaded(){
        }

        protected onSetLandscape(){
        }

        protected onSetPortrait(){
        }

        public onInitialize(): void {
        }
    }

}


// WEBPACK FOOTER //
// src/typescript/Game/Views/Game/ResultTableView.ts